import type { GithubDeploymentAuthItem } from '../types';

const storageKey = 'deployment-dashboard.github-deployment-auth';

export interface GithubDeploymentAuthDraft {
  state: string;
  redirectUri: string;
  deployments: GithubDeploymentAuthItem[];
  createdAt: string;
}

export interface GithubAuthorizationCallbackParams {
  code: string;
  state: string;
}

export const createGithubAuthorizationState = (): string => {
  const bytes = new Uint8Array(24);
  window.crypto.getRandomValues(bytes);

  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
};

export const saveGithubDeploymentAuthDraft = (draft: GithubDeploymentAuthDraft) => {
  window.sessionStorage.setItem(storageKey, JSON.stringify(draft));
};

export const loadGithubDeploymentAuthDraft = (): GithubDeploymentAuthDraft | undefined => {
  const rawDraft = window.sessionStorage.getItem(storageKey);

  if (!rawDraft) {
    return undefined;
  }

  try {
    const draft = JSON.parse(rawDraft) as GithubDeploymentAuthDraft;

    if (!draft.state || !draft.redirectUri || !Array.isArray(draft.deployments)) {
      return undefined;
    }

    return draft;
  } catch {
    return undefined;
  }
};

export const clearGithubDeploymentAuthDraft = () => {
  window.sessionStorage.removeItem(storageKey);
};

export const getGithubAuthorizationCallbackParams = ():
  | GithubAuthorizationCallbackParams
  | undefined => {
  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');
  const state = params.get('state');

  if (!code || !state) {
    return undefined;
  }

  return { code, state };
};

export const removeGithubAuthorizationCallbackParamsFromUrl = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete('code');
  url.searchParams.delete('state');

  window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
};
